import { render, staticRenderFns } from "./ActionLogs.vue?vue&type=template&id=b57408ca&"
import script from "./ActionLogs.vue?vue&type=script&lang=ts&"
export * from "./ActionLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports